<p-dialog
    [visible]="visible"
    (visibleChange)="visibleChange.emit($event)"
    [modal]="true"
    [style]="{ width: '75vw', 'max-width': '1100px' }"
    [closable]="true"
    [dismissableMask]="true"
    [baseZIndex]="10000"
    [breakpoints]="{ '960px': '85vw', '640px': '95vw' }"
    [header]="headerText">
    <div class="repeatable-info-dialog">
        @for (section of view?.sections ?? []; track $index) {
            @if (section.title) {
                <h4 class="repeatable-info-section-title">{{ section.title }}</h4>
            }

            @for (table of section.tables; track $index) {
                <table class="table table-striped table-bordered w-100" [ngClass]="table.styleClass ?? 'product-info-table'">
                    <thead>
                        <tr>
                            @for (header of table.headers; track $index) {
                                <th>{{ header }}</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of table.rows; track $index) {
                            <tr>
                                @for (cell of row; track $index) {
                                    <td>{{ cell }}</td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            }
        }
    </div>

    <ng-template pTemplate="footer">
        <div class="product-info-actions">
            <p-button label="Cerrar" (click)="close()"></p-button>
        </div>
    </ng-template>
</p-dialog>
